const html = window.html;
const Backbone = window.Backbone;
const smallScreen =
    window.OverDrive.isTolinoDevice || $(document).width() <= 870;

import SubjectModel from '../models/SubjectModel';
import SubjectItemView from './SubjectItemView';
import keys from '../../../util/keycodes';

class SubjectCollectionView extends Backbone.View {
    template(model) {
        let expanded = !smallScreen || this.collection.length === 1;
        let headerId = `acc-header-${model.cid}`;
        let contentId = `acc-content-${model.cid}`;
        return `
            <li class="SubjectCollection accordion-navigation"> 
                <div class="DropdownContainer">
                    <div id="${headerId}" class="DropdownTitle" aria-expanded="${expanded}" 
                        aria-controls="${contentId}"  tabindex="0" role="button">
                        <h2 class="subjectHeading">${model.title}</h2>
                        <i id="icon" class="${
                            expanded ? 'icon-down-arrow' : 'icon-forward-arrow'
                        } panel-arrow right chevron" aria-hidden="true"></i> 
                    </div>
                    <div class="subjectInfo ${
                        expanded ? 'expanded' : ''
                    }" id="${contentId}" role="region" aria-labelledby="${headerId}">
                        <ul class="SubjectItems BrowseSubjects"></ul>
                    </div>
                </div>
            </li>`;
    }

    // Converts subject mediatype responses into their localized display value keys for use with html()
    get labelMap() {
        return {
            all: 'all',
            ebook: 'ebooks',
            audiobook: 'audiobooks',
            magazine: 'magazines',
            video: 'videos',
        };
    }

    initialize() {
        this.listenTo(this.collection, 'update', this.render);
    }

    render() {
        let $temp = $('<ul class="accordion" data-accordion />');

        // Remove the current grouping if no subjects were returned
        this.collection.each((item) => {
            if (item) {
                let subjectCollection = item.toJSON();
                if (_(subjectCollection.subjects).isEmpty()) {
                    this.collection.remove(item);
                }
            }
        });

        // ref: /business-objects/SubjectCollection
        this.collection.each((item) => {
            let subjectCollection = item.toJSON();

            let $subjectCollectionView = $(
                this.template({
                    title: this._getTitleFromSubjectCollection(
                        subjectCollection
                    ),
                    cid: item.cid,
                })
            );

            let $subjectItems = $subjectCollectionView.find('.SubjectItems');

            // Sort the subjects alphabetically
            subjectCollection.subjects.sort((a, b) =>
                a.name.toUpperCase() < b.name.toUpperCase() ? -1 : 1
            );

            if (!smallScreen) {
                this._addSubjectsToSubjectCollection(
                    subjectCollection,
                    $subjectItems
                );
            } else {
                $subjectCollectionView.on(
                    'click keyup',
                    '.DropdownTitle',
                    (e) => {
                        if (!this.isSelectEvent(e)) {
                            return;
                        }
                        let $subjectItems =
                            $subjectCollectionView.find('.SubjectItems');

                        if ($subjectItems.children().length <= 1) {
                            this._addSubjectsToSubjectCollection(
                                subjectCollection,
                                $subjectItems
                            );
                        }
                    }
                );
            }

            $temp.append($subjectCollectionView);
        });

        this.$el.empty().append($temp);

        this.$el.on('click keyup', '.DropdownTitle', (e) => {
            e.stopImmediatePropagation();
            if (!this.isSelectEvent(e)) {
                return;
            }
            let $disappearingDiv = $(e.currentTarget)
                .parent()
                .find('.subjectInfo');
            let icon = $(e.currentTarget).find('.panel-arrow');

            $disappearingDiv.toggleClass('expanded');
            $(e.currentTarget).attr(
                'aria-expanded',
                $disappearingDiv.hasClass('expanded')
            );
            icon.toggleClass('icon-down-arrow');
            icon.toggleClass('icon-forward-arrow');
        });

        this.$el.on('keydown', '.DropdownTitle', (e) => {
            if (e.which === keys.SPACE) {
                e.preventDefault();
            }
        });
    }

    _addSubjectsToSubjectCollection(subjectCollection, $subjectItems) {
        _(subjectCollection.subjects).each((subject) => {
            let subjectViewModel = new SubjectModel(subject).toViewModel(
                subjectCollection.subjectParameters
            );
            let subjectItemView = new SubjectItemView({
                model: new Backbone.Model(subjectViewModel),
            });
            $subjectItems.append($('<li />').append(subjectItemView.el));
        });
    }

    _getTitleFromSubjectCollection(subjectCollection) {
        // This parallels /services/SubjectService.js
        let parentSubjectIds = [
            26, // Fiction
            111, // Nonfiction
            43, // Juvenile Fiction
            45, // Juvenile Nonfiction
            127, // Young Adult Fiction
            128, // Young Adult Nonfiction
        ];

        let labelParts = [];

        let parentSubjectId = _(
            subjectCollection.subjectParameters.subject
        ).find((id) => _(parentSubjectIds).contains(id));
        if (parentSubjectId) {
            labelParts.push(html(`subjects.${parentSubjectId}`));
        }

        let mediaType = subjectCollection.subjectParameters.mediaType;
        if (mediaType && mediaType !== 'all') {
            labelParts.push(html(this.labelMap[mediaType]));
        }

        return labelParts.join(' ');
    }

    isSelectEvent = (e) =>
        (e.type === 'click' ||
            e.which === keys.ENTER ||
            e.which === keys.SPACE) &&
        (e.preventDefault() || true);
}

export default SubjectCollectionView;
